(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.howToChoose = {
    attach: function(context, settings) {

      const setJumpLinks = function() {
        if (jQuery('.can-jump-wrapper').length === 0) {
          const $canSectionHeaders = jQuery('.block-inline-blockhow-to-choose-can-section-header');
          const $canJumpLinks = jQuery('<div class="can-jump-wrapper"></div>');
          const $jumpLinkSection = $canSectionHeaders.first().parent().parent();

          $canJumpLinks.append('<h2 class="jump-links-title">Select an option to learn more</h2>');

          $canSectionHeaders.each(function() {
            const target = this.id;
            const title = jQuery(this).find('.field--name-field-section-heading').text();
            const $jumpLink = jQuery('<a class="can-jump-link" href="#' + target + '">' + title + '</a>');
            $canJumpLinks.append($jumpLink);
          });

          $jumpLinkSection.prepend($canJumpLinks);
        }
      };

      jQuery(document).ready(function() {
        setJumpLinks();
      });
    }
  };
})(jQuery, Drupal);
